export { default } from './UniversalChip';
